import * as Yup from 'yup'

const fastSellProductInboundFormSchema = Yup.object().shape({
  inbound_courier: Yup.string().required(
    'Inbound courier harus diisi'
  ),
  inbound_shipping_no: Yup.string().required(
    'Inbound shipping no harus diisi'
  )
})

export default fastSellProductInboundFormSchema
